module.exports = __webpack_public_path__ + "static/media/206-header1.2de07172.jpg";